export const  Skils = ()=> {
    return   (
        <>
            <ul>
                <li>PHP (Symfony, Laravel)</li>
                <li>HTML, CSS (Sass, Less)</li>
                <li>JavaScript (React)</li>
                <li>Linux</li>
                <li>SQL</li>
                <li>NoSQL</li>
                <li>Git</li>
                <li>Docker</li>
                <li>Jira</li>
            </ul>
        </>
    )
}
